import {$createParagraphNode, $getSelection, $isRangeSelection, LexicalEditor} from "lexical"
import {$setBlocksType} from "@lexical/selection"
import {$createQuoteNode} from "@lexical/rich-text"
import {$createCodeNode} from "@lexical/code"

type Blocks = 'code' | 'quote'

const debug = false
// const debug = "lexicalChangeBlock"

export function lexicalChangeBlock(editor: LexicalEditor, currentBlockType: Blocks, newBlockType: Blocks) {
    switch (newBlockType) {
        case 'code'     : {
            const createNode = currentBlockType !== 'code' ? $createCodeNode : $createParagraphNode

            editor.update(() => {
                let selection = $getSelection();

                if ($isRangeSelection(selection)) {
                    if (selection.isCollapsed()) {
                        $setBlocksType(selection, () => createNode());
                    } else {
                        const textContent = selection.getTextContent();
                        const codeNode = createNode();
                        selection.insertNodes([codeNode]);
                        selection = $getSelection();
                        if ($isRangeSelection(selection))
                            selection.insertRawText(textContent);
                    }
                }
            })
        } break

        case 'quote'    : {
            const createNode = currentBlockType !== 'quote' ? $createQuoteNode : $createParagraphNode

            editor.update(() => {
                const selection = $getSelection()
                if ($isRangeSelection(selection)) {
                    $setBlocksType(selection, () => createNode())
                }
            })
        } break
    }
}